import React, { useState, SetStateAction, Dispatch, useEffect } from 'react';
import { strings } from 'src/localization';
import * as css from './MaintContractVehLayout.module.scss';
import SVPButton from '../../SVPButtons/SVPButton';
import AdditionalService from '../../AdditionalServices/AdditionalService/containers/AdditionalService';
import { CustMode } from 'src/enums';
import { ascCtaInteractionInput, ascElementConfigurationInput, MCData, VehicleRec } from 'src/models';
import { ascCtaInteraction, ascElementConfiguration } from 'src/helpers/EventHelper/EventHelper';
import classNames from 'classnames';
export interface IPropState {
    model: string,
    make: string,
    year: string,
    MCData: MCData,
    custMode: CustMode,
    vin: string,
    lexusMCLaunched: string,
    toyotaMCLaunched: string,
    theme: string;
    vehicles: VehicleRec[],
    selectedVehicle?: string,
}

const MaintContractVehLayout = (props: IPropState) => {
    const [showContracts, getContracts] = useState(false);
    const [inqryRtn, setInqryRtn] = useState({ invoked: false, returned: false });
    const [, setMCLength]:
        [undefined | number, Dispatch<SetStateAction<number | undefined>>] = useState();
    const checkContracts = (e:any) => {
        getContracts(true);
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'search',
            elementText: strings.CheckContracts,
            elementColor: '',
            elementOrder: '',
            elementType: 'search_tool',
            elementSubType: 'other_buttons',
            eventAction: 'click',
            eventActionResult: 'search',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
        const ascElementConfigurationInp: ascElementConfigurationInput = {
            pageType: 'service',
            elementText: strings.CheckContracts,
            elementType: 'search_tool',
            elementColor: '',
            eventAction: 'click',
            eventActionResult: 'search',
            linkUrl: '',
        };
        ascElementConfiguration(ascElementConfigurationInp, e, props.vehicles, props.selectedVehicle);
    };
    let contractMsg = strings.CheckMC;

    let mcOutput = (
        <div
            className={css.mcBtn}
        >
            <SVPButton
                id='chkMaintContracts'
                variant='secondaryBtnAlt'
                message={strings.CheckContracts}
                handler={checkContracts}
                tooltip={strings.MaintContractTip}
                theme={props.theme}
            />
        </div>
    );
    if (showContracts) {
        contractMsg = strings.formatString(strings.MaintContractLinked, props.year, props.model ?? props.make).toString();

        if (props.MCData.MCReturned) {
            mcOutput = (
                <div className={css.addtnlSvcBrdr}>
                    <div className={css.addtnlSvc}>
                        <AdditionalService
                            type='Maintenance Contract'
                            vehLayoutCard
                            inqryRtnState={setInqryRtn}
                            setMCLength={setMCLength}
                        ></AdditionalService>
                    </div>
                </div>
            );
        } else {
            mcOutput = (
                <AdditionalService
                    type='Maintenance Contract'
                    vehLayoutCard
                    inqryRtnState={setInqryRtn}
                    setMCLength={setMCLength}
                ></AdditionalService>
            );
        }

        if (props.MCData.MCError) {
            contractMsg = strings.MaintContractError;
            mcOutput=(<AdditionalService
                type='Maintenance Contract'
                vehLayoutCard
                inqryRtnState={setInqryRtn}
                setMCLength={setMCLength}
            ></AdditionalService>);
        }

        if (props.MCData.maintContracts.length === 0 && !props.MCData.MCError && props.MCData.MCReturned) {
            contractMsg = `${strings.NoOustandingMC} ${props.year} ${props.model ?? props.make}.`;
            mcOutput = (
                <div id='noMaintContracts' className={css.noMCBrdr}>
                    <div className={css.noMC}>
                        <h4 className={css.noMCRow}>{strings.zeroNumb}</h4>
                        <div className={css.noMCRow}>{strings.MaintenanceContractsFound}</div>
                    </div>
                    <AdditionalService
                        type='Maintenance Contract'
                        vehLayoutCard
                        inqryRtnState={setInqryRtn}
                        setMCLength={setMCLength}
                    ></AdditionalService>
                </div>
            );
        }
    }

    if (inqryRtn.invoked && !props.MCData.MCReturned && !props.MCData.MCError) {
        contractMsg = strings.PullingMaintContracts;
    }

    useEffect(() => {
        if (props.custMode === CustMode.CheckMaintContract) {
            const MCcard = document.getElementById('contractMsg');
            if (MCcard) {
                MCcard.scrollIntoView(false);
            }
            getContracts(true);
        }
    }, [props.custMode]);

    const summaryTitleCSS = classNames(
        css.summaryTitle,
        {
            [css.summaryTitleBMW]: props.theme === 'bmw',
            [css.summaryTitleFord]: props.theme === 'ford',
            [css.summaryTitleMazda]: props.theme === 'mazda',
            [css.summaryTitleAcura]: props.theme === 'acura',
            [css.summaryTitleGenesis]: props.theme === 'genesis',
        },
    );
    // if (props.theme === 'buick') {
    //     summaryTitleCSS = css.summaryTitleBuick;
    // }
    // if (props.theme === 'dodge') {
    //     summaryTitleCSS = css.summaryTitleDodge;
    // }

    // const contractMsgCSS = props.theme === 'bmw' ? css.contractMsgBMW : null;

    return (
        <div>
            <hr className={css.topHr} />
            <h4 className={summaryTitleCSS}>{strings.MaintenanceContracts}</h4>
            <div id='contractMsg' className={''}>
                {contractMsg}
            </div>
            {mcOutput}
        </div>
    );
};

export default MaintContractVehLayout;